function SectionHeader({ text }) {
    return (<label className="font-bold text-sm">
        {text}
    </label>)
}

export default SectionHeader